import { sodApi } from "@/services";

export const userApi = sodApi.injectEndpoints({
  endpoints: (builder) => ({
    // TODO: replace fetchFn with a custom fetch wrapper that handles the token
    getUserPhoto: builder.query({
      query: () => '/User/ProfilePicture',
    }),
    verifyUserAccount: builder.mutation<void, { displayName: string }>({
      query: (body) => ({
        url: '/User/Verify',
        method: 'POST',
        body,
      }),
    }),
    createUserSession: builder.mutation<{ sessionStart: string; sessionExpiration: string; sessionId: string }, void>({
      query: () => ({
        url: '/UserSession/CreateSession',
        method: 'POST',
      }),
    }),
    endUserSession: builder.mutation<void, void>({
      query: () => ({
        url: '/UserSession/EndSession',
        method: 'POST',
      }),
    }),
    checkUserSession: builder.query<string, void>({
      query: () => ({
        url: `/UserSession/CheckSession`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetUserPhotoQuery,
  useVerifyUserAccountMutation,
  useCreateUserSessionMutation,
  useEndUserSessionMutation,
  useCheckUserSessionQuery,
} = userApi;
